export default {
  data() {
    return {
      allKeys: [ // 全部可用字段
        {
          title: `包类型`,
          name: '',
          value: undefined,
          key: 'instrumentsetType',
          apiKey: 'instrumentset_type',
          apiTextKey: '',
          methodType: 'select',
          optionType: 'Type',
          isDict: true,
          required: false,
          showFormat:'printForm',
          isPublic:false, // 判断该数据在批量打印时，是公共标签还是，独立标签
        },
        {
          title: `器械包名称`,
          name: '',
          value: undefined,
          key: 'name',
          apiKey: 'instrumentset_id',
          apiTextKey: 'instrumentset_name',
          methodType: 'select',
          optionType: 'Package',
          isDict: false,
          required: true,
          showFormat:'printForm',
          isPublic:false,
        },
        {
          title: `灭菌器`,
          name: '',
          value: undefined,
          key: 'sterilizer',
          apiKey: 'equipment_id',
          apiTextKey: 'equipment_name',
          methodType: 'select',
          optionType: 'Sterilizer',
          isDict: false,
          required: true,
          showFormat:'printForm',
          isPublic:true,
        },
        {
          title: `灭菌锅次`,
          name: '',
          value: undefined,
          key: 'sterilizePot',
          apiKey: 'sterilization_pot_frequency',
          apiTextKey: '',
          methodType: 'number',
          optionType: '',
          isDict: false,
          required: true,
          showFormat:'printForm',
          isPublic:true,
        },
        {
          title: `灭菌时间`,
          name: '',
          value: undefined,
          key: 'sterilizeDate',
          apiKey: 'sterilization_time',
          apiTextKey: '',
          methodType: 'datetime',
          optionType: '',
          isDict: false,
          required: true,
          showFormat:'dateTimeTypes',
          isPublic:true,
        },
        {
          title: `灭菌失效时间`,
          name: '',
          value: undefined,
          key: 'sterilizeDeadline',
          apiKey: 'sterilization_expire_time',
          apiTextKey: '',
          methodType: 'datetime',
          optionType: '',
          isDict: false,
          required: true,
          showFormat:'dateTimeTypes',
          isPublic:false,
        },
        {
          title: `灭菌方式`,
          name: '',
          value: undefined,
          key: 'sterilizeMethod',
          apiKey: 'handle_option',
          apiTextKey: '',
          methodType: 'select',
          optionType: 'SterilizeMethod',
          isDict: true,
          required: false,
          showFormat:'printForm',
          isPublic:true,
        },
        {
          title: `包装人`,
          name: '',
          value: undefined,
          key: 'packageUser',
          apiKey: 'package_uid',
          apiTextKey: 'package_name',
          methodType: 'select',
          optionType: 'User',
          isDict: false,
          required: true,
          showFormat:'printForm',
          isPublic:false,
        },
        {
          title: `组配人`,
          name: '',
          value: undefined,
          key: 'packUser',
          apiKey: 'pack_uid',
          apiTextKey: 'pack_name',
          methodType: 'select',
          optionType: 'User',
          isDict: false,
          required: false,
          showFormat:'printForm',
          isPublic:false,
        },
        {
          title: `审核人`,
          name: '',
          value: undefined,
          key: 'checkUser',
          apiKey: 'check_uid',
          apiTextKey: 'check_name',
          methodType: 'select',
          optionType: 'User',
          isDict: false,
          required: false,
          showFormat:'printForm',
          isPublic:false,
        },
        {
          title: `灭菌人`,
          name: '',
          value: undefined,
          key: 'sterilizeUser',
          apiKey: 'sterilization_uid',
          apiTextKey: 'sterilization_name',
          methodType: 'select',
          optionType: 'User',
          isDict: false,
          required: false,
          showFormat:'printForm',
          isPublic:false,
        },
        {
          title: `回收科室`, // 字段名称
          name: '', // 字段值（文本）
          value: undefined, // 字段值（系统值）
          key: 'recycleDepartment', // 字段标识
          apiKey: 'recycle_department_id', // 提交接口对应key（取用value）
          apiTextKey: 'recycle_department_name', // 提交接口对应文字key（取用text）
          methodType: 'select', // 字段添加类型（select，number， datetime（date/datetime），list，label，input）
          optionType: 'Department', // 下拉选项类型（只有下拉框使用）(User, Department, Package, Type, Sterilization, Pack)
          isDict: false,
          required: false,
          showFormat:'printForm', // 当鼠标移入时显示的是哪个数组的值
          isPublic:false, // 判断该数据在批量打印时，是公共标签还是，独立标签
        },
        {
          title: `发放科室`,
          name: '',
          value: undefined,
          key: 'outDepartment',
          apiKey: 'out_department_id',
          apiTextKey: 'out_department_name',
          methodType: 'select',
          optionType: 'Department',
          isDict: false,
          required: false,
          showFormat:'printForm',
          isPublic:false,
        },
        {
          title: `归属科室`,
          name: '',
          value: undefined,
          key: 'insDepartment',
          apiKey: 'ins_department_id',
          apiTextKey: 'ins_department_name',
          methodType: 'select',
          optionType: 'Department',
          isDict: false,
          required: false,
          showFormat:'printForm',
          isPublic:false,
        },
        {
          title: `包装材料`,
          name: '',
          value: undefined,
          key: 'packOption',
          apiKey: 'pack_option',
          apiTextKey: '',
          methodType: 'select',
          optionType: 'Pack',
          isDict: true,
          required: false,
          showFormat:'printForm',
          isPublic:false,
        },
        {
          title:  `器械明细`,
          name: `器械明细`,
          value: [],
          key: 'instrumentList',
          apiKey: 'instruments',
          apiTextKey: '',
          methodType: 'list',
          list: [
            {
              name: `器械名称`,
              number: `数量`
            }
          ],
          optionType: '',
          isDict: false,
          required: false,
          showFormat:'equipmentDeta',
          isPublic:false,
        },
        {
          title: `图片`,
          name: '',
          value: undefined,
          key: 'image',
          apiKey: 'tenant_image',
          apiTextKey: '',
          methodType: 'logo',
          optionType: '',
          isDict: true,
          required: false,
          showFormat:'imageTypes',
          isPublic:false,
        },
        {
          title: `流水号`,
          name: '',
          value: undefined,
          key: 'serial_number',
          apiKey: '',
          apiTextKey: '',
          methodType: 'serial_number',
          optionType: '',
          isDict: false,
          required: false,
          showFormat:'printForm',
          // showFormat:'',
          // isPublic:false,
        },
      ],
      defaultStyle: { // 默认样式
        width: 50,
        height: 50,
        x: 0,
        y: 0,
        fontSize: 12,
        lineHeight: 14,
        bold: 0,
        textAlign: 'left'
      },
      dateTimeTypes: [ // 时间日期类型
        // {
        //   key: 'time',
        //   title: `时分秒`
        // },
        {
          key: 'date',
          title: `年月日`
        },
        {
          key: 'datetime',
          title: `年月日 + 时分秒`
        }
      ],
      imgTypes: ['qrcode', 'code128','datamatrix'], // 码图类型
      imageTypes: [ // 图片类型
        {
          key: 'logo',
          title: `logo`
        },
        // {
        //   key: 'material',
        //   title: `素材`
        // }
      ],
      equipmentDeta: [ // 器械明细
        {
          key: 'list',
          title: `字符`
        }
      ],
      disabledKeys: [], // 不可编辑字段（打印状态）
      printForm:[
        {
          key:'select',
          title: `字符`
        },
        {
          key:'qrcode',
          title: `二维码`
        },
        
        {
          key:'code128',
          title: `一维码`
        },
        {
          key:'datamatrix',
          title: `DM码`
        }], // 图片类型
        tabIdenCode:[ "instrumentset_id", "equipment_id", "sterilization_pot_frequency", "sterilization_time", "sterilization_expire_time", "package_uid" ], // 标签识别码中要打印的值

    }
  },
  computed: {
    // _allMethodTypes(data) {
    //   console.log('data',data)
    //   // return this.imageTypes.concat(this.dateTimeTypes)
    // }
  },
  methods: {
    _allMethodTypes(data){
      if(this[data.showFormat]){ // 如果设置了hover框，则显示
        return true
      }else{
        return false
      }
    },
    _addMethodTypes(data) { // 通过字段上面的methodType来确定使用哪个选项字段
      // const methodTypekeys = ['dateTimeTypes', 'imageTypes']
      // let types = []
      // methodTypekeys.forEach(i => {
      //   if (this[i].map(i => i.key).includes(methodType)) {
      //     types = this[i]
      //   }
      // })
      // return types
      let types = []
      if(data.showFormat){
        return this[data.showFormat]
      }
    }
  }
}